// extracted by mini-css-extract-plugin
export const form = "editPassword-module--form--yUf4k";
export const input = "editPassword-module--input--XAxao";
export const inputFile = "editPassword-module--inputFile--aLgld";
export const errorMsg = "editPassword-module--errorMsg--VhoYb";
export const btnUpdate = "editPassword-module--btnUpdate--5YSVZ";
export const profileImage = "editPassword-module--profileImage--tt1rD";
export const profileSection = "editPassword-module--profileSection--KVdFp";
export const btnUpload = "editPassword-module--btnUpload--Oqb60";
export const passwordTitle = "editPassword-module--passwordTitle--PhfeR";